import {
  DropdownCheckEntry,
  DropdownCheckGroup,
  DropdownMenu,
} from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAssetsTableStore } from '../useAssetsTableStore';
import { getDefaultInsightsFilterState } from '../utils';

type InsightsHeaderCellProps = {
  header: JSX.Element;
};

export const InsightsHeaderCell = ({ header }: InsightsHeaderCellProps) => {
  const { t } = useTranslation('widget');
  const insightsFilterState = useAssetsTableStore(
    state => state.insightsFilterState
  );

  const checkItems: DropdownCheckEntry[] = Object.entries(
    insightsFilterState
  ).map(([key, val]) => {
    return {
      key: key,
      /** i18next-extract-mark-context-next-line ["Macro", "Technical", "Fundamental", "RelatedAssets"] */
      label: t('widget:insights:analysisType', {
        context: key,
      }),
      checked: val,
    };
  });

  const onChange = (key: string, checked: boolean) => {
    useAssetsTableStore.setState(prev => ({
      insightsFilterState: {
        ...prev.insightsFilterState,
        [key]: checked,
      },
    }));
  };

  const toggleAll = (checked: boolean) => {
    useAssetsTableStore.setState({
      insightsFilterState: getDefaultInsightsFilterState(checked),
    });
  };

  return (
    <DropdownMenu
      triggerNode={header}
      key="insights-header-cell"
      align="end"
      data-testid="insights-filter-menu"
    >
      <DropdownCheckGroup
        items={checkItems}
        onChange={onChange}
        label={t('widget:insights:filterData')}
        selectAllLabel={t('widget:insights:allInsights')}
        toggleAll={toggleAll}
      />
    </DropdownMenu>
  );
};
